export const IconLink = ({ size = 9, color = "#fff" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 9 9"
  >
    <g id="sr-link" transform="translate(-2.757 -2.757)">
      <path
        id="Path_1492"
        data-name="Path 1492"
        d="M13.064,8.089a.487.487,0,0,0,.689,0l.974-.974a2.553,2.553,0,0,0-3.61-3.61l-.974.974a.487.487,0,0,0,.689.689l.974-.974a1.579,1.579,0,0,1,2.233,2.233l-.974.974A.487.487,0,0,0,13.064,8.089Z"
        transform="translate(-3.716 0)"
        fill={color}
      />
      <path
        id="Path_1493"
        data-name="Path 1493"
        d="M3.5,14.726a2.553,2.553,0,0,0,3.61,0l.974-.974a.487.487,0,1,0-.689-.689l-.974.974A1.579,1.579,0,0,1,4.194,11.8l.974-.974a.487.487,0,1,0-.689-.689l-.974.974A2.553,2.553,0,0,0,3.5,14.726Z"
        transform="translate(0 -3.716)"
        fill={color}
      />
      <path
        id="Path_1494"
        data-name="Path 1494"
        d="M8.831,11.753a.487.487,0,0,1-.689-.689l2.921-2.921a.487.487,0,0,1,.689.689Z"
        transform="translate(-2.69 -2.69)"
        fill={color}
      />
    </g>
  </svg>
);
